// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"b8f2b83b","667":"f3756dcc","895":"5fe79137","977":"240addac","998":"6bbd3e71"}[chunkId] + ".chunk.js";
};